import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Filter out AngularFire zoneless warning (safe to ignore with zoneless change detection)
const originalWarn = console.warn;
console.warn = function (...args) {
   const message = args[0];
   if (
      typeof message === 'string' &&
      message.includes('Calling Firebase APIs outside of an Injection context')
   ) {
      return; // Suppress the warning
   }
   originalWarn.apply(console, args);
};

/**
 * kottra-admin's "Manage Store" opens `/?impersonate=<storeId>&impersonateName=…`
 * because it can't write this origin's localStorage. Persist the keys before
 * bootstrap so UserService/MainLayout pick them up, then strip them from the
 * URL. UserService only honours them for `users.isAdmin` accounts.
 */
function consumeImpersonationHandoff(): void {
   const url = new URL(window.location.href);
   const storeId = url.searchParams.get('impersonate');
   if (storeId === null) return;
   try {
      if (/^[A-Za-z0-9_-]{1,128}$/.test(storeId)) {
         localStorage.setItem('admin_impersonated_store', storeId);
         localStorage.setItem(
            'admin_impersonated_store_name',
            url.searchParams.get('impersonateName') || storeId,
         );
      }
   } catch {
      // Storage blocked — open normally without impersonating.
   }
   url.searchParams.delete('impersonate');
   url.searchParams.delete('impersonateName');
   history.replaceState(history.state, '', url.pathname + url.search + url.hash);
}

consumeImpersonationHandoff();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
   console.error(err),
);
